import React from 'react';

import { useFormContext } from 'react-hook-form';

import { useFetchCountries } from 'components/Pages/Admin/Itineraries/shared/hooks/useFetchCountries';
import { Select } from 'components/shared/Select/adapters/HookForm';

import sharedStyles from '../../../../../shared/index.module.css';
import { GoogleMapsAdapter, NameSection, TagsSection } from '../../../shared';
import * as types from '../../../types';

function AreaForm() {
  const methods = useFormContext<types.AreaFormValues>();
  const { control } = methods;
  const countriesQueryRes = useFetchCountries();
  const handledCountries =
    countriesQueryRes.data?.data.map((item) => ({ value: item.id.toString(), label: item.name })) || [];

  return (
    <div>
      <div className={sharedStyles.sectionContainer}>
        <NameSection control={control}>Area Name</NameSection>

        <Select
          name="countryId"
          control={control}
          label={() => 'Select Country*'}
          options={handledCountries}
          getOptionLabel={(option) => option?.label}
          getOptionValue={(option) => option?.value}
          isLoading={countriesQueryRes.isLoading}
          optionToString
          isClearable
        />
      </div>

      <TagsSection methods={methods} />

      <GoogleMapsAdapter<types.AreaFormValues> {...methods} />
    </div>
  );
}

export { AreaForm };
